import { useReactiveVar } from '@apollo/client';
import { currentRoutingTabVar } from './currentRoutingTab';
export function useCurrentRoutingTab() {
    return useReactiveVar(currentRoutingTabVar);
}
